<template>
  <div class="w-view-shell">
    <!-- 面包屑  -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>全部课程</el-breadcrumb-item>
      <el-breadcrumb-item class="ke">{{
        play_info.course_name
      }}</el-breadcrumb-item>
    </el-breadcrumb>
    
    <div class="video-view-shell">
      <div class="video-shell">
        <video
          id="myVideo"
          controls
          :src="play_info.file_url"
          controlslist="noplaybackrate nodownload noremoteplayback disablePictureInPicture"
          :poster="public_img"
          oncontextmenu="return false;" 
          ondragstart="return false;"
          disablePictureInPicture="true"
          @play="play"
          @pause="pause"
          @ended="ended"
          @error="error"
          @waiting="waiting"
          @ratechange="onratechange"
        >
          对不起，您的浏览器暂不支持video视频标签!
        </video>
      </div>
    </div>

    <!--视频抓拍-->
    <div
      class="video-photo-shell"
      v-show="photo_show"
      @click.stop="stopNavigator"
    >
      <div class="camera_outer" @click.stop="">
        <div class="title" v-if="photo_type == 1">人脸识别</div>
        <div class="title" v-if="photo_type == 3">上传头像</div>
        <div class="photo-tips" v-if="photo_type == 1">
          温馨提示：请将肩膀以上正脸对准框内拍照。
        </div>
        <div class="photo-tips" v-if="photo_type == 3">
          温馨提示：您还未上传头像,请上传本人真实照片,用于后续进行人脸识别!
        </div>
        <div
          class="submit-photo-btn"
          @click.stop="first_up_img()"
          v-if="photo_type == 1"
        >
          点击识别
        </div>
        <div
          class="submit-photo-btn"
          @click.stop="up_user_img()"
          v-if="photo_type == 3"
        >
          点击拍照
        </div>
        <video
          id="videoCamera"
          :width="videoWidth"
          :height="videoHeight"
          autoplay
        ></video>
        <canvas
          style="display:none;"
          id="canvasCamera"
          :width="videoWidth"
          :height="videoHeight"
        ></canvas>
      </div>
    </div>

    <!-- 提示 -->
    <div
      class="video-photo-shell"
      v-show="applet_show"
      @click.stop="applet_show = false"
    >
      <div class="camera_outer">
        <div class="title">
          电脑需安装或自带摄像头， 若没有, 您可以扫码关注公众号进行学习
        </div>
        <img src="@/assets/gzh.jpg" alt="" class="applet-img" />
      </div>
    </div>

    <!-- 评价 -->
    <el-dialog
      width="30%"
      title="学习评价"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="evaluate">
        <span>请您对本堂课程学习进行评价</span>
        <div class="check">
          <div>
            <el-radio v-model="checked" label="1" border size="medium"
              >非常满意</el-radio
            >
          </div>
          <div>
            <el-radio v-model="checked" label="2" border size="medium"
              >基本满意</el-radio
            >
          </div>
        </div>
        <div class="check">
          <div>
            <el-radio v-model="checked" label="3" border size="medium"
              >一般满意</el-radio
            >
          </div>
          <div>
            <el-radio v-model="checked" label="4" border size="medium"
              >不太满意</el-radio
            >
          </div>
        </div>
        <div class="hint">您对本堂课程学习的建议(非必填)：</div>
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          style="width: 70%;font-size: 18px;"
          placeholder="非必填"
          v-model="remark"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </span>
    </el-dialog>

    <!-- 考核 -->
    <el-dialog
      center
      width="30%"
      title="随堂考核"
      v-if="topic_list.length > 0"
      :visible.sync="examShow"
    >
      <div class="exam">
        <div class="topic">
          <span
            >{{ topicIdx + 1 }}{{ topic_list[topicIdx].qst_type | setType
            }}</span
          >
          {{ topic_list[topicIdx].qst_name }}
        </div>
        <div
          class="answer"
          v-for="(item, index) in topic_list[topicIdx].qst_info"
          :key="index"
          :class="{'answer_sel': item.checked}"
          @click="handleAnswer(index)"
        >
          <div>{{ index | topicLi }}</div>
          <span>{{ item.option }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleExam">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="30%"
      title="温馨提示"
      align="center"
      :visible.sync="advise">
      <div class="advise">
        <p>您的公需课已学完，约4小时后可电脑端进省局平台（https://yaoshi.hnmpaed.com/）查询学分卡。</p>
      </div>
      <span slot="footer" class="advise_footer">
        <el-button type="primary" @click="advise = false">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Coursetobuy",
  data() {
    return {
      applet_show: false, // 摄像头提示
      course_id: 0, // 课程id 
      play_info: {
        directory_name: "视频详情",
        file_url: "",
      },
      public_img: '',
      is_finish: 0,
      photo_time: [],
      course_type: 3,
      play_time: 0,
      current_play_time: 0,
      // 抓拍
      videoWidth: 430, 
      videoHeight: 320, 
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      photo_show: false,
      video_timer: null,
      allow_camera: false,
      user_info: "",
      photo_type: 1, // 1 第一次拍照 2 后续拍照 3 未上传头像
      old_play_time: 0,
      handle_allow: true,
      dialogVisible: false, // 评价弹窗
      remark: "", // 评价备注
      checked: "1", // 评价等级
      examShow: false, // 随堂考核
      topicIdx: 0, // 考试题目下标
      topic_list: [], // 考试题目
      playRoot: true, // 播放权限
      endTime: 0, // 最新播放进度
      advise: false,
      year: ''
    };
  },
  filters: {
    topicLi(i) {
      if (i == 0) return "A";
      if (i == 1) return "B";
      if (i == 2) return "C";
      if (i == 3) return "D";
    },
    setType(value) {
      if (value == 0) {
        return "单选";
      }
      if (value == 1) {
        return "多选";
      }
      if (value == 2) {
        return "判断";
      }
    },
  },
  created() {
    this.year = this.$route.query.year
    this.course_id = this.$route.query.course_id;
  },
  mounted() {
    this.handle_allow = true;
    this.getUserInfo();
  },
  destroyed() {
    this.up_study_log();
    window.clearInterval(this.timer_log);
    window.clearInterval(this.video_timer);
    let video = document.getElementById("myVideo");
    video.removeEventListener('enterpictureinpicture', this.vidoe_forbid);
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      this.API.post("user/user_infos-user_info", {}).then((res) => {
        this.user_info = res.data.user_info;
        this.cut_play();
        this.$emit("get-info");
      });
    },
    // 检测用户头像
    cut_play() {
      let video = document.getElementById("myVideo");
      if (video) {
        video.currentTime = 0;
      }
      this.old_play_time = 0;
      this.API.post2("user/user_infos-thumb_status", {}).then((res) => {
        if (res.errno == 0) {
          if (res.data.thumb_status) {
            this.photo_type = 1;
            window.clearInterval(this.timer_log);
            this.get_phar_play();
          } else {
            this.photo_type = 3;
            this
            .$confirm(
              "上传头像前请确保您的设备有摄像头且已打开!",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true,
              }
            )
            .then((r) => {
              this.getCompetence();
            })
            .catch((r) => {});
          }
        } else {
          this.API.SMessage(res.message);
        }
      });
    },
    // 获取视频详情
    get_phar_play() {
      this.API.post("user/public_in-public_play", {
        course_id: this.course_id,
        version: 10
      }).then((res) => {
        if (res.errno != 0) {
          if (res.code == 2078) {
            this.photo_type = 3;
            this.getCompetence();
          }
          return;
        }
        this.public_img = res.data.public_img
        // 人脸识别
        if (res.data.play_info.is_photo == 1) {
          this.photo_type = 1
          this
            .$confirm(
              "播放视频前请确保您已上传真实头像,并且设备有摄像头且已打开!",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true,
              }
            )
            .then((r) => {
              this.getCompetence();
            })
            .catch((r) => {});
        } else {
          this.play_info = res.data.play_info;
          this.play_info.play_time = Number(this.play_info.play_time)
          if (this.play_info.play_time > this.play_info.file_time) {
            this.play_info.play_time = this.play_info.file_time
          }
          this.record_id = this.play_info.record_id;
          this.play_time = this.play_info.play_time;
          if (this.play_info.is_finish == 1 && this.play_info.is_comment == 0) {
            this.dialogVisible = true;
            return;
          }
          this.getPublicTopic();
          let video = document.getElementById("myVideo");
          video.addEventListener('enterpictureinpicture', this.vidoe_forbid);
        }
      });
    },
    vidoe_forbid (e) {
      e.preventDefault();
      if (document.pictureInPictureElement) {
        document.exitPictureInPicture();
      }
    },
    // 获取题目
    getPublicTopic() {
      this.API.post("user/public_in-get_question_public", {
        course_id: this.course_id,
      }).then((res) => {
        if (res.errno != 0) {
          this.API.SMessage(res.message);
          return;
        }

        let list = res.data.question_list;
        list.push({eject_time: this.play_info.file_time + 3, qst_info: []})
        for (let i in list) {
          if (list[i].eject_time > this.play_info.play_time) {
            this.topicIdx = Number(i)
            break;
          } else {
            this.topicIdx = Number(i)
          }
        }
        this.photo_time = [];
        list.forEach((item) => {
          this.photo_time.push(item.eject_time);
          item.qst_info.forEach(v => {
            v.checked = false
          })
        });
        this.topic_list = list;

        // 监听视频播放进度
        setTimeout(() => {
          let _this = this;
          let video = document.getElementById("myVideo");
          video.currentTime = _this.play_time;
          video.play()
          _this.old_play_time = _this.play_info.play_time;
          _this.current_play_time = _this.play_time;
          video.addEventListener("timeupdate", function() {
            let timeDisplay;
            timeDisplay = Math.ceil(video.currentTime);
            _this.video_uptime(video.currentTime);
            // 抓拍
            if (_this.photo_time.length > 0) {
              if (
                _this.current_play_time >= _this.photo_time[_this.topicIdx] && _this.current_play_time < _this.photo_time[_this.topicIdx+1]
              ) {
                console.log(_this.photo_time[_this.topicIdx])
                let video = document.getElementById("myVideo");
                video.pause();
                // 弹题
                _this.playRoot = false;
                _this.examShow = true;
              }
            }
          });
        }, 800);

        // 学习记录
        if (this.play_info.is_finish == 0) {
          let video = document.getElementById("myVideo");
          this.timer_log = setInterval(() => {
            if (video && !video.paused) {
              this.up_study_log();
            }
          }, 1000 * 3);
        }
      });
    },
    onratechange () {
      let video = document.getElementById("myVideo");
      video.playbackRate = 1
    },

    // 调用权限（打开摄像头功能）https
    getCompetence() {
      window.clearInterval(this.video_timer);
      this.photo_show = true;
      let _this = this;
      _this.thisCancas = document.getElementById("canvasCamera");
      _this.thisContext = this.thisCancas.getContext("2d");
      _this.thisVideo = document.getElementById("videoCamera");
      _this.thisVideo.style.display = "block";
      // 获取媒体属性，旧版本浏览器可能不支持mediaDevices，我们首先设置一个空对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
      // 使用getUserMedia，因为它会覆盖现有的属性。
      // 这里，如果缺少getUserMedia属性，就添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
          // 首先获取现存的getUserMedia(如果存在)
          var getUserMedia =
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.getUserMedia;
          // 有些浏览器不支持，会返回错误信息
          // 保持接口一致
          if (!getUserMedia) {
            //不存在则报错
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }
          // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
          return new Promise(function(resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }
      var constraints = {
        audio: false,
        video: {
          width: this.videoWidth,
          height: this.videoHeight,
          transform: "scaleX(-1)",
        },
      };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function(stream) {
          // 摄像头可以正常使用
          _this.allow_camera = true;
          // 旧的浏览器可能没有srcObject
          if ("srcObject" in _this.thisVideo) {
            _this.thisVideo.srcObject = stream;
          } else {
            // 避免在新的浏览器中使用它，因为它正在被弃用。
            _this.thisVideo.src = window.URL.createObjectURL(stream);
          }
          _this.thisVideo.onloadedmetadata = function(e) {
            _this.thisVideo.play();
          };
        })
        .catch((err) => {
          _this.allow_camera = false;
          _this.photo_show = false;
          _this.applet_show = true;
          // _this.$alert('摄像头开启失败,请确定您已在设置打开摄像头,并且已允许本网站使用您的摄像头!', '提示', {
          //   confirmButtonText: '确定',
          //   callback: action => {
          //   }
          // })
        });
    },

    // 上传用户头像
    up_user_img() {
      let _this = this;
      if (!_this.allow_camera) {
        return;
      }
      // canvas画图
      _this.thisContext.drawImage(
        _this.thisVideo,
        0,
        0,
        _this.videoWidth,
        _this.videoHeight
      );
      // 获取图片base64链接
      let image = _this.thisCancas.toDataURL("image/png");
      _this.dealImage(image, 600, function(base64) {
        image = base64;
        let fd = new FormData();
        fd.append("token", localStorage.getItem("token"));
        fd.append("file", image);
        _this.API.post("user/user_infos-upload_img", fd).then((r) => {
          _this.API.post("user/user_infos-edit_user", {
            head_img: r.data.file_path,
            sex: _this.user_info.sex ? _this.user_info.sex : 1,
            nick_name: _this.user_info.nick_name,
            company_id: _this.user_info.company_id || 0,
          }).then((res) => {
            _this.stopNavigator();
            _this.API.SMessage("头像上传成功");
            _this.getUserInfo();
            _this.get_phar_play();
          });
        });
      });
    },
    // 点击人脸识别
    first_up_img() {
      if (!this.handle_allow) {
        return this.API.SMessage("操作过于频繁");
      }
      this.handle_allow = false;
      setTimeout(() => {
        this.handle_allow = true;
      }, 2000);
      let _this = this;
      if (!_this.allow_camera) {
        return;
      }
      // canvas画图
      _this.thisContext.drawImage(
        _this.thisVideo,
        0,
        0,
        _this.videoWidth,
        _this.videoHeight
      );
      // 获取图片base64链接
      let video = document.getElementById("myVideo");
      video.pause();
      let image = _this.thisCancas.toDataURL("image/png");
      _this.dealImage(image, 600, function(base64) {
        image = base64;
        let fd = new FormData();
        fd.append("token", localStorage.getItem("token"));
        fd.append("file", image);
        _this.API.post("user/user_infos-upload_img", fd).then((res2) => {
          _this.API.post("user/course_in-snapshot", {
            img_url: res2.data.file_path,
            course_type: 3
          }).then((res) => {
            if (res.errno == 0) {
              _this.API.SMessage("验证成功");
              _this.stopNavigator();
              _this.get_phar_play()
            } else {
              _this.stopNavigator();
              setTimeout(() => {
                _this
                  .$confirm(res.message + ",请确定是本人后重试?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                  })
                  .then(() => {
                    _this.getCompetence();
                  })
              }, 30);
            }
          });
        });
      });
    },
    // 压缩照片
    dealImage(base64, w, callback) {
      var newImage = new Image();
      var quality = 0.8; //压缩系数0-1之间
      newImage.src = base64;
      newImage.setAttribute("crossOrigin", "Anonymous"); //url为外域时需要
      var imgWidth, imgHeight;
      newImage.onload = function() {
        imgWidth = this.width;
        imgHeight = this.height;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (Math.max(imgWidth, imgHeight) > w) {
          if (imgWidth > imgHeight) {
            canvas.width = w;
            canvas.height = (w * imgHeight) / imgWidth;
          } else {
            canvas.height = w;
            canvas.width = (w * imgWidth) / imgHeight;
          }
        } else {
          canvas.width = imgWidth;
          canvas.height = imgHeight;
          quality = 0.6;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
        var base64 = canvas.toDataURL("image/jpeg", quality); //压缩语句
        callback(base64);
      };
    },
    // 关闭摄像头
    stopNavigator() {
      this.thisVideo.srcObject.getTracks()[0].stop();
      setTimeout(() => {
        this.photo_show = false;
      }, 10);
    },

    // 控制视频进度调整
    video_uptime(time) {
      let video = document.getElementById("myVideo");
      let currentTime = time;
      let dif = currentTime - this.old_play_time
      if (this.play_info.is_finish == 0 || this.play_info.is_comment == 0) {
        if (dif > 1.5) {
          video.pause()
          if (this.endTime != 0 && currentTime < this.endTime) {
            this.old_play_time = time;
          } else if (this.endTime != 0 && currentTime >= this.endTime) {
            video.currentTime = this.endTime;
            this.endTime = 0
            this.API.SMessage("未学习完课程,请不要快进");
          } else {
            video.currentTime = this.old_play_time;
            this.API.SMessage("未学习完课程,请不要快进"); 
          }
        } else if (dif < 0) {
          if (this.old_play_time > this.endTime) {
            this.endTime = this.old_play_time
            video.pause()
          }
        } else {
          this.current_play_time = parseInt(time);
          this.old_play_time = time;
        }
      } else {
        this.current_play_time = parseInt(time);
        this.old_play_time = time;
      }
    },
    // 监听视频播放
    play() {
      let video = document.getElementById("myVideo");
      let time = Math.ceil(video.currentTime);
      if (!this.playRoot && time >= this.endTime) {
        this.examShow = true
        video.pause()
        return
      }
    },
    // 监听视频暂停
    pause() {
      window.clearInterval(this.video_timer);
      this.up_study_log();
    },
    // 监听视频播放完毕
    ended() {
      if (this.play_info.file_time - this.current_play_time < 5) {
        if (this.play_info.is_finish == 0 && this.play_info.is_comment == 0) {
          this.dialogVisible = true;
        }
        this.up_study_log();
        window.clearInterval(this.video_timer);
      } else {
        let video = document.getElementById("myVideo");
        video.pause()
      }
    },
    // 监听视频播放错误
    error() {
      // this.API.SMessage('视频播放出错,请手动进行刷新,再点击播放!')
      window.clearInterval(this.video_timer);
    },
    // 监听视频播放警告
    waiting() {
      // this.API.SMessage('网络不稳定,您可以点击暂停待视频缓冲后再进行播放')
    },

    // 上传学习记录
    up_study_log() {
      // 上传学习记录 
      if (this.play_info.is_finish == 1 || this.play_info.is_record == 0) {
        return;
      }
      if (this.old_play_time - this.endTime < 0) {
        return;
      }
      this.API.post2("user/course_in-learn_in", {
        directory_id: 0,
        course_id: this.play_info.course_id,
        course_type: 3,
        record_id: this.play_info.record_id,
        play_time: this.current_play_time,
      }).then((res) => {
        if (res.code == 2081) {
          window.clearInterval(this.timer_log);
        }
      });
    },

    // 选择答案
    handleAnswer(i) {
      let arr = this.topic_list[this.topicIdx].qst_info;
      arr[i].checked = !arr[i].checked;
      if (this.topic_list[this.topicIdx].qst_type != 1) {
        arr.forEach((item, index) => {
          if (index != i) {
            item.checked = false
          }
        })
      }
      this.topic_list[this.topicIdx].qst_info = arr
    },
    // 提交考试答案
    handleExam() {
      let checked = false
      let arr = this.topic_list[this.topicIdx].qst_info
      if (this.topic_list[this.topicIdx].qst_type == 1) {
        let qst_answer = ''
        arr.forEach((item, index) => {
          if (item.checked) {
            qst_answer = qst_answer + (index+1)
          }
        })
        if (qst_answer === this.topic_list[this.topicIdx].qst_answer) {
          checked = true
        } else {
          checked = false
        }
      } else {
        arr.forEach((item, index) => {
          if (item.checked) {
            if ((index+1) != this.topic_list[this.topicIdx].qst_answer) {
              checked = false
            } else {
              checked = true
            }
          }
        })
      }
      if (checked) {   
        this.topicIdx++
        this.playRoot = true       
        this.examShow = false
        let video = document.getElementById("myVideo");
        video.play();
        this.API.SMessage("考核成功");
      } else {
        this.$message.error('答案错误，请重新答题！');
      }
    },

    // 提交学习评价
    handleSubmit() {
      this.dialogVisible = false;
      this.API.post2("user/public_in-push_comment", {
        score: this.checked,
        content_text: this.remark,
        course_id: this.play_info.course_id,
        record_id: this.play_info.record_id,
      }).then((res) => {
        if (this.play_info.is_finish == 1 && this.play_info.is_comment == 0) {
          this.get_phar_play();
        }
        this.getRate()
      });
    },
    getRate () {
      this.API.post2("user/phar_in-public_end", {
        year: this.year,
      }).then((res) => {
        if (res.errno == 1) {
          this.advise = true
        } else {
          this.$router.back()
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>
.video-view-shell {
  margin-bottom: 40px;

  .video-shell {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1200px;
    background-color: #f8f8f8;
    margin-bottom: 30px;

    video {
      width: 100%;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 400;
  color: #000;
  cursor: text;
}

.el-breadcrumb {
  height: 47px;
  line-height: 47px;
}

.video-photo-shell {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 99;

  .applet-img {
    width: 300px;
    height: 300px;
    margin: 20px auto;
  }

  .camera_outer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 610px;
    padding: 20px 0;
    background-color: #fff;
    border: 1px solid #ccc;
    position: relative;

    .title {
      width: 100%;
      font-weight: 600;
      height: 60px;
      border-bottom: 1px solid #eee;
      font-size: 20px;
      padding: 0 30px;
    }

    .photo-tips {
      display: flex;
      align-items: center;
      width: 100%;
      height: 50px;
      padding: 0 30px;
      color: red;
    }

    .submit-photo-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      height: 50px;
      width: 40%;
      color: #fff;
      background-color: rgb(0, 98, 204);
      margin: 20px auto;
      cursor: pointer;
    }
  }

  .img_bg_camera {
    width: 100%;
  }

  .tx_img {
    width: 300px;
    height: 300px;
    margin: 0 auto;
  }
}

.evaluate {
  display: flex;
  flex-direction: column;
  align-items: center;
  > span {
    text-align: center;
    font-size: 1.2em;
  }
  .check {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 30px;
  }
  .hint {
    margin: 20px 0 5px;
    width: 70%;
  }
}

.exam {
  .topic {
    font-size: 20px;
    span {
      font-size: 20px;
      background-color: #2aa9b5;
      color: #fff;
      display: inline-block;
      padding: 0 5px;
      margin-right: 5px;
    }
  }
  .answer {
    display: flex;
    align-items: center;
    margin-top: 20px;
    cursor: pointer;
    div {
      font-size: 20px;
      width: 30px;
      height: 30px;
      line-height: 30px;
      border-radius: 50%;
      border: 1px solid #888888;
      text-align: center;
      margin-right: 10px;
    }
    span {
      flex: 1;
      font-size: 20px;
    }
  }
  .answer_sel {
    span {
      color: #2aa9b5;
    }
    div {
      color: #2aa9b5;
      border-color: #2aa9b5;
    }
  }
}

.advise {
  p {
    text-indent: 35px;
    width: 100%;
    text-align: left;
  }
  img {
    margin: 20px auto 0;
    width: 300px;
    display: block;
  }
}
.advise_footer {
  display: flex;
  justify-content: center;
}
</style>
